module.exports = __webpack_public_path__ + "media/fonts/material-design-icons/materialdesignicons-webfont-3a6518ff5844b36f0890463bcd7071e7.woff";